var nurseslounge_myDashboard_colleagues = {
    init:function($params){
        var $pages;
        if($params && $params.guestId){
            $pages = ['my-colleagues', 'common'];
        }else{
            $pages = ['all-colleagues', 'my-colleagues', 'sent-invite', 'received-invite'];
        }
        $.each($pages, function($i, $v){
            nurseslounge_myDashboard_colleagues.colleagues_pagination($params, $v);
        });
        nurseslounge_myDashboard_colleagues.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
        nurseslounge_myDashboard_colleagues.recommended_friends(function($chtml){
            nurseslounge_myDashboard_colleagues.recommended_friends_container($params, $chtml);
        });
        nurseslounge_myDashboard_colleagues.invite_colleagues(function($config){
            nurseslounge_myDashboard_myProfile.invite_colleagues_engine($config);
        });
        nurseslounge_myDashboard_activity.lounge_follow_request(function($chtml){
            nurseslounge_myDashboard_colleagues.lounge_follow_container($chtml);
        });
        nurseslounge_myDashboard_myProfile.profile_is_complete($params, true);
        nurseslounge_myDashboard_colleagues.task_list_container(function($container){
            nurseslounge_myDashboard_myProfile.task_list($container, $params);
        });
        nurseslounge_myDashboard_colleagues.preview_profile_container(function($container){
            nurseslounge_myDashboard_myProfile.preview_profile($container, $params);
        });
    },
    colleagues_pagination:function($params, $id){
        $params = $.extend({}, $params,{show:$id});
        var $reload;
        var $loaded = false;
        var $afterFirstPagination = false;
        var $colleagues = $("#nurseslounge-home-collagues .nurseslounge-home-collagues-left");
        var $section = $colleagues.find("#"+$id);
        var $colleaguesList = $section.find('.colleagues-list');
        var $paginationNav = $section.find('.pagination-nav');
        var $previewHeight = $section.find('.colleagues-list .preview:first').innerHeight();
        var $colleaguesHeight = $section.innerHeight();
        if(!libs.memoryGet('pageSize')){
            var $pageSize = Math.round(($colleaguesHeight/$previewHeight)) == 'Infinity' ? 10 : Math.round(($colleaguesHeight/$previewHeight));
            libs.memorySave('pageSize', $pageSize);
        }
        var $resultInfo = $section.find(".result-info-count:first");
        var $paginationObj;
        try{
            $paginationObj = libs.memoryGet('colleagues_'+$id);
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        $paginationObj = $paginationNav.pagination({
            pageSize: libs.memoryGet('pageSize'),
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource:window.location.protocol +'//'+ window.location.hostname + "/myDashboard/colleagues/friends/get",
            locator: 'data.colleagues',
            ajax:{
                method: "POST",
                cache:false,
                dataType: "json",
                data:$params,
                beforeSend: function() {
                    $colleaguesList.html(nurseslounge_myDashboard_colleagues.colleagues_preview());
                },
                complete:function($data){
                    libs.expire($data.responseJSON);
                    $("#nurseslounge-home-collagues .nurseslounge-home-collagues-left .nav-pills .nav-item a").each(function($i, $v){
                        var $that = $($v);
                        if($that.data('target') == '#'+$id){
                            $that.find('span').html($data.responseJSON.data.total);
                        }
                    });
                }
            },
            totalNumberLocator: function($data) {
                return $data.data.total;
            },
            callback: function($data, $pagination) {
                $loaded = true;
                if($colleaguesList.length > 0 && $colleaguesList.offset().top > 0 && $afterFirstPagination){
                    $('html, body').animate({scrollTop:$colleaguesList.offset().top - 100});
                }else{
                    $afterFirstPagination = true;
                }
                var $id = $colleaguesList.parents('.tab-pane:first').attr('id');
                var $pageNumber = $pagination.pageNumber;
                var $pageSize = $pagination.pageSize;
                var $totalNumber = $pagination.totalNumber;
                var $first = $totalNumber > 0 ? (($pageNumber-1) * $pageSize) + 1 : 0;
                var $last = $totalNumber > 0 ? ($first + $data.length - 1) : 0;
                $paginationNav.removeClass('nurseslounge-home-collagues-preload');
                if($id != 'all-colleagues') {
                    $resultInfo.removeClass('nurseslounge-home-collagues-preload').html('<strong>Showing ' + $first + ' - ' + $last + ' of ' + $totalNumber + '</strong> results for <span class="link-color">Colleagues</span>');
                }else{
                    $resultInfo.removeClass('nurseslounge-home-collagues-preload').html('');
                }
                $params = $.extend({}, $params,{show:$id});
                var $chtml = nurseslounge_myDashboard_colleagues.colleagues_home_item_html($data, $params);
                libs.checkImageLoad($($chtml).find('img'), function () {
                    $colleaguesList.html('').html($chtml).promise().done(function () {
                        nurseslounge_myDashboard_colleagues.colleagues_home_list_events($params);
                    });
                });
            }
        });
        libs.memorySave('colleagues_'+$id, $paginationObj);
        $reload = setTimeout(function(){
            if(!$loaded){
                nurseslounge_myDashboard_colleagues.colleagues_pagination($params, $id);
            }else{
                clearTimeout($reload);
            }
        }, 10000);
    },
    colleagues_preview:function(){
        var $chtml = '';
        for(var $i=1; $i<=10; $i++){
            $chtml+= '' +
                '<li class="shadow p-3 mb-3 bg-white rounded preview">' +
                '    <div class="row">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-3 nurseslounge-home-collagues-preload">' +
                '                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <h4 class="nurseslounge-home-collagues-preload">' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </h4>' +
                '                    <p class="nurseslounge-home-collagues-preload">' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </p>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-md-auto text-center text-sm-right align-self-center nurseslounge-home-collagues-preload">' +
                '           <div class="col-md-auto text-center text-sm-right align-self-center">' +
                '        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '           </div>' +
                '        </div>' +
                '    </div>' +
                '</li>' +
                '';
        }
        return $chtml;
    },
    filter_by:function($v, $type){
        var $lounges = [];
        $.each($v.lounges, function ($k, $v) {
            if($v.type == $type){
                if($v.lounge_name != null){
                    $lounges.push($v.lounge_name);
                }else{
                    $lounges.push($v.lounge.name);
                }
            }
        });
        return $lounges.join(', ');
    },
    colleagues_home_item_html:function($colleagues, $params){
        var $chtml = '';
        $.each($colleagues, function($i, $v){
            var $img = $v.profile_image_root_friend;
            $chtml+='' +
                '<li class="shadow p-3 mb-3 bg-white rounded item" data-id="'+$v.id+'" data-url="'+$v.profile_url+'" data-name="'+$v.long_name+'">' +
                '    <div class="row">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-3">' +
                '                    <img src="'+$img+'?resize=80" alt="profile">' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <h4 class="">' +
                $v.long_name+
                '                    </h4>' +
                '                    <p class="">';
                var $append = [];
                var $job = $v.job_title;
                if($job){
                    $append.push($job);
                }
                switch(parseInt($v.profile.id)){
                    case 1:
                        $append.push(nurseslounge_myDashboard_colleagues.filter_by($v,'employer'));
                        break;
                    case 2:
                        $append.push(nurseslounge_myDashboard_colleagues.filter_by($v,'organization'));
                        break;
                    case 3:
                        $append.push(nurseslounge_myDashboard_colleagues.filter_by($v,'school'));
                        break;
                    case 4:
                        $append.push(nurseslounge_myDashboard_colleagues.filter_by($v,'employer'));
                        break;
                }
                $chtml+= $append.join(', ');
                $chtml+='' +
                '                    </p>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-md-auto text-center text-sm-right align-self-center ">' +
                '           <div class="col-md-auto text-center text-sm-right align-self-center">';
                if(!$params.guestId) {
                    if ($params.show == 'all-colleagues') {
                        $chtml += '' +
                            //'<button type="button" class="btn btn-light option" data-action="6">Block Colleague</button>' +
                            '<button type="button" class="btn btn-save btnAnimate option" data-action="1">Connect</button>';
                    }
                    if ($params.show == 'my-colleagues') {
                        $chtml += '' +
                            //'<button type="button" class="btn btn-light option" data-action="6">Block Colleague</button>' +
                            '<button type="button" class="btn btn-save btnAnimate option" data-action="5">Remove Colleague</button>';
                    }
                    if ($params.show == 'sent-invite') {
                        $chtml += '' +
                            //'<button type="button" class="btn btn-light option" data-action="6">Block Colleague</button>' +
                            '<button type="button" class="btn btn-save btnAnimate option" data-action="2">Cancel Invite</button>';
                    }
                    if ($params.show == 'received-invite') {
                        $chtml += '' +
                            '<button type="button" class="btn btn-light option" data-action="4">Reject Invite</button>' +
                            '<button type="button" class="btn btn-save btnAnimate option" data-action="3">Accept Invite</button>';
                    }
                    //if ($params.show == 'blocked') {
                    //    $chtml += '' +
                    //        '<button type="button" class="btn btn-light option" data-action="7">Unblock Collegue</button>';
                    //}
                }
            $chtml+='' +
                '           </div>' +
                '        </div>' +
                '    </div>' +
                '</li>';
        });
        return $chtml;
    },
    colleagues_home_list_events:function($saveParams){
        var $colleagues = $("#nurseslounge-home-collagues .nurseslounge-home-collagues-left");
        var $section = $colleagues.find("#"+$saveParams.show);
        var $bindKeyPress;
        var $form = $section.find('form:first');
        $form.submit(function($e){
            $e.preventDefault();
            var $that = $(this);
            try{
                clearTimeout($bindKeyPress);
            }catch ($e) {

            }
            $bindKeyPress = setTimeout(function(){
                $saveParams = $.extend({}, $saveParams, {search:$that.val()});
                nurseslounge_myDashboard_colleagues.colleagues_pagination($saveParams, $saveParams.show);
            }, 800);
        });
        $form.find('input[name="search"]').unbind().on('keyup keydown keypress', function(){
            var $that = $(this);
            try{
                clearTimeout($bindKeyPress);
            }catch ($e) {

            }
            $bindKeyPress = setTimeout(function(){
                $saveParams = $.extend({}, $saveParams, {search:$that.val()});
                nurseslounge_myDashboard_colleagues.colleagues_pagination($saveParams, $saveParams.show);
            }, 800);
        });
        var $colleaguesList = $section.find('.colleagues-list .item');
        $colleaguesList.find('.option').unbind().click(function($e){
            $e.stopPropagation();
            var $that = $(this);
            var $item = $that.parents('.item:first');
            var $toUserId = $item.data('id');
            var $url = $item.data('url');
            var $name = $item.data('name');
            var $action = $that.data('action');
            if($action == 1){
                nurseslounge_myDashboard_colleagues.colleagues_invitation_modal($url, $name, function($ok){
                    if($ok){
                        var $params = $.extend({}, $saveParams, {to_user_id: $toUserId, status_id: $action});
                        nurseslounge_myDashboard_colleagues.colleagues_home_set($params, function () {
                            nurseslounge_myDashboard_colleagues.init($saveParams);
                        });
                    }
                });
            }else {
                var $params = $.extend({}, $saveParams, {to_user_id: $toUserId, status_id: $action});
                nurseslounge_myDashboard_colleagues.colleagues_home_set($params, function () {
                    nurseslounge_myDashboard_colleagues.init($saveParams);
                });
            }
        });
        $colleaguesList.unbind().click(function () {
            var $that = $(this);
            var $profileUrl = $that.data('url');
            router.navigate($profileUrl,true);
        });
    },
    colleagues_invitation_modal:function($url, $name, cback){
        var $modal = $("#nurseslounge-home-my-profile-invitations-modal");
        $modal.find('.user-name').attr('href',$url).html($name);
        $modal.find('.send').unbind().click(function(){
            $modal.modal('hide');
            cback(true);
        });
        $modal.modal('show');
    },
    colleagues_home_set:function($params, cback){
        $.ajax({
            method: 'POST',
            url:'/myDashboard/colleagues/friends/set',
            data:$params,
            dataType: "json",
            success: function($data){
                libs.expire($data);
                if($data.status == 'success'){
                    if(cback != undefined) {
                        cback();
                    }
                }
            }
        });
    },
    //Recommended Friends
    recommended_friends:function(cback){
        $.ajax({
            method: 'POST',
            url: '/myDashboard/colleagues/friends/get',
            data: {
                show : "recommended",
                pageSize:4,
                pageNumber:1,
                user_id: libs.memoryGet('user_id')
            },
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                if ($data.status == 'success') {
                    var $chtml = '';
                    $.each($data.data.colleagues, function($i, $v){
                        $chtml += nurseslounge_myDashboard_colleagues.recommended_friends_html($v);
                    });
                    cback($chtml);
                }
            }
        });
    },
    recommended_friends_html:function($v){
        var $img = $v.profile_image_root_friend;
        return '' +
            '<li data-id="'+$v.id+'" data-name="'+$v.long_name+'" data-url="'+$v.profile_url+'" class="open-profile">' +
            '   <div class="row">' +
            '       <div class="col-sm-12">' +
            '           <div class="d-flex">' +
            '               <div class="profile-img img-objectfit mr-3">' +
            '                   <img src="'+$img+'?resize=48" alt="education">' +
            '               </div>' +
            '               <div class="list-info align-self-center">' +
            '               <h4>' +
            '                   <a href="javascript:void(0)">'+$v.long_name+'</a>' +
            '               </h4>' +
            '               <a href="javascript:void(0)" class="send-friend-request">Connect</a>' +
            '               </div>' +
            '           </div>' +
            '       </div>' +
            '   </div>' +
            '</li>';
    },
    //Recommended Friends
    recommended_friends_container:function($params, $chtml){
        if($chtml == ''){
            $("#nurseslounge-home-collagues .nurseslounge-home-collagues-right .invite-colleagues").parents('.card:first').remove();
            return false;
        }
        libs.checkImageLoad($($chtml).find('img'), function(){
            $("#nurseslounge-home-collagues .nurseslounge-home-collagues-right .invite-colleagues").html($chtml).promise().done(function(){
                $(this).find(".open-profile").unbind().click(function(){
                    var $guestId = $(this).data('id');
                    router.navigate('/profile/'+$guestId);
                });
                $(this).find(".send-friend-request").unbind().click(function($e){
                    $e.stopPropagation();
                    var $li = $(this).parents('li:first');
                    var $toUserId = $li.data('id');
                    var $name = $li.data('name');
                    var $url = $li.data('url');
                    nurseslounge_myDashboard_colleagues.colleagues_invitation_modal($url, $name, function($ok){
                        if($ok){
                            $li.fadeOut().remove();
                            var $params = {user_id:libs.memoryGet('user_id'),to_user_id:$toUserId, status_id:1};
                            nurseslounge_myDashboard_colleagues.colleagues_home_set($params, function () {
                                nurseslounge_myDashboard_colleagues.init($params);
                            });
                        }
                    });
                });
            });
        });
    },
    //Banners
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-home-collagues .nurseslounge-home-collagues-right .banners")
        });
    },
    //Invite Colleagues
    invite_colleagues:function(cback){
        cback({
            'colleagues':$("#nurseslounge-home-collagues .nurseslounge-home-collagues-right .send-invite:first")
        });
    },
    //Follow Lounges
    lounge_follow_container:function($chtml){
        libs.checkImageLoad($($chtml).find('img'), function(){
            $("#nurseslounge-home-collagues .nurseslounge-home-collagues-right .follow-lounges").html($chtml);
        });
    },
    //Task List Container
    task_list_container:function(cback){
        var $container = $("#nurseslounge-home-collagues .nurseslounge-home-collagues-right");
        cback($container);
    },
    //Preview Profile
    preview_profile_container:function(cback){
        var $container = $("#nurseslounge-home-collagues .nurseslounge-home-collagues-right");
        cback($container);
    },
};
